import { brandConfig } from '@/config/brandConfig';

export interface TemplateSender {
  name: string;
  address: string;
  phone: string;
}

export function defaultTemplateSender(): TemplateSender {
  return {
    name: brandConfig.name.toUpperCase(),
    address: [brandConfig.address, brandConfig.cityStateZip].filter(Boolean).join('\n'),
    phone: brandConfig.phone,
  };
}

export function templateCopyCount(value: string): number | null {
  if (!/^\d+$/.test(value.trim())) return null;
  const count = Number(value);
  return Number.isInteger(count) && count >= 1 && count <= 100 ? count : null;
}

export function addressTemplatePages(count: number, perPage: 3 | 4): number[][] {
  if (!Number.isInteger(count) || count < 1 || count > 100 || ![3, 4].includes(perPage))
    throw new Error('Choose 1 to 100 copies and three or four labels per sheet.');
  return Array.from({ length: Math.ceil(count / perPage) }, (_, page) =>
    Array.from(
      { length: Math.min(perPage, count - page * perPage) },
      (_, i) => page * perPage + i + 1,
    ),
  );
}
